import { createFileRoute } from "@tanstack/react-router";
import { redirectIntoScope } from "@/app/router/legacy-redirect";

/** Old unscoped URL: `/analytics/…` → `/{store}/analytics/…`. */
export const Route = createFileRoute("/analytics/$")({ beforeLoad: redirectIntoScope });
